import { useState } from "react";
import { Button, Modal, Popup } from "semantic-ui-react";

import ScheduleViewContactsTable from "routes/campaign/components/email_schedule_contacts_table/ScheduleViewContactsTableV3";
import PageContainer from "components/PageContainer";

function EmailableContactsModal({ disabled, campaignId, data }) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      trigger={
        <Popup
          disabled={!disabled}
          content={
            "Please select a template and fill out at least one filter condition"
          }
          trigger={
            <span>
              <Button
                type="button"
                size="tiny"
                content="View Contacts"
                disabled={disabled}
                onClick={handleOpen}
              />
            </span>
          }
        />
      }
      size="large"
      open={modalOpen}
      onClose={handleClose}
      closeIcon
    >
      <Modal.Header>Email Schedule Contacts</Modal.Header>
      <Modal.Content>
        <PageContainer styles={{ height: "80vh", padding: "0px" }}>
          <ScheduleViewContactsTable campaignId={campaignId} data={data} />
        </PageContainer>
      </Modal.Content>
    </Modal>
  );
}

export default EmailableContactsModal;
